export const getInnerHTMLByClassName = (htmlDocument: Document, className: string, index: number) => {
    const elements = htmlDocument.getElementsByClassName(className)
    return elements.length ? elements[index].innerHTML : ''
}
